import { useCallback, useEffect, useRef, useState } from "react"

import { Row } from "react-bootstrap"
import { toast } from "react-toastify"
import { Subscription } from "rxjs"
import { finalize } from "rxjs/operators"

import ClinicGroupsFFModal from "./ClinicGroupsFFModal"
import ExcludeClinicGroupTable from "./ExcludeClinicGroupTable"
import {
  DeleteExcludedClinicGroupsObservable,
  GetExcludedClinicGroupsObservable,
} from "../../../../api/Clinics/ClinicGroupsGet"
import { ClinicGroupSelected } from "../../../../api/Clinics/Models/ClinicGroup"
import FormatError from "../../../../formatters/FormatError"
import ActionButton from "../../../ActionButton"

function ExcludeClinicGroup() {
  const [groups, setGroups] = useState<ClinicGroupSelected[]>([])
  const [refresh, setRefresh] = useState(false)
  const [loadingGroups, setLoadingGroup] = useState(false)
  const [removingGroups, setRemovingGroups] = useState(false)

  const subsRef = useRef({
    subs: new Subscription(),
  })

  useEffect(() => {
    const { subs } = subsRef.current
    return () => subs.unsubscribe()
  }, [])

  useEffect(() => {
    setLoadingGroup(true)
    subsRef.current.subs.add(
      GetExcludedClinicGroupsObservable()
        .pipe(finalize(() => setLoadingGroup(false)))
        .subscribe(
          (data) =>
            setGroups(
              data.map<ClinicGroupSelected>((group) => ({
                ...group,
                selected: false,
              }))
            ),
          (error) => toast.error(FormatError(error))
        )
    )
  }, [refresh])

  const handleHideClinicGroupsFFModal = useCallback(() => {
    setRefresh((prev) => !prev)
  }, [])

  const handleGroupClick = useCallback((group: ClinicGroupSelected) => {
    setGroups((prev) =>
      prev.map((p) => (p.SearchRestrictId === group.SearchRestrictId ? { ...p, selected: !group.selected } : p))
    )
  }, [])

  const handleRemoveGroup = useCallback(() => {
    setRemovingGroups(true)
    subsRef.current.subs.add(
      DeleteExcludedClinicGroupsObservable(groups.filter((g) => g.selected))
        .pipe(finalize(() => setRemovingGroups(false)))
        .subscribe(
          (data) => {
            setGroups((prev) => prev.filter((g) => !g.selected))
            toast.success(data)
          },
          (error) => toast.error(FormatError(error))
        )
    )
  }, [groups])

  return (
    <>
      <h5 className="mb-0">Exclude by FormFox Clinic Group</h5>
      <ExcludeClinicGroupTable onSelectGroup={handleGroupClick} loadingGroups={loadingGroups} groups={groups} />
      <Row className="buttons-block">
        <ClinicGroupsFFModal onHide={handleHideClinicGroupsFFModal} excludedGroups={groups} />
        <ActionButton
          variant="secondary"
          className="mr-1"
          onClick={handleRemoveGroup}
          disabled={groups.every((g) => !g.selected)}
          spin={removingGroups}
          disableOnSpin
        >
          Remove
        </ActionButton>
      </Row>
    </>
  )
}

export default ExcludeClinicGroup
